module.exports = __webpack_public_path__ + "static/media/investor.2df37a3d.png";